import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function GoogleAnalytics() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Uncover Actionable Insights with Google Analytics
                </div>
              </div>

              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We decode website data to provide clear insights that drive
                business growth. Our structured approach identifies patterns and
                tracks user behavior. This makes sure that businesses make
                informed decisions to improve marketing performance.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Actionable Insights"
                  subtitle1="Uncover trends to drive smarter decisions."
                  title2="Real-Time Tracking"
                  subtitle2="Monitor user behavior as it happens."
                  title3="Simplified Reporting"
                  subtitle3="Turn complex data into clear visuals."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={<h2>Google Analytics for Smarter Business Decisions</h2>}
            subtitle={
              <div>
                At Riches Media Digital, we implement Google Analytics
                strategies that provide deep insights into user behavior and
                campaign performance. Our team configures tracking setups and
                analyzes key metrics. We make sure that businesses understand
                visitor interactions and optimize digital experiences. Our
                data-backed approach improves decision-making and multiplies
                return on investment.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/googleanalytics.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our Google Analytics Setup Process"}
            invert={!dark}
            step1={"Data Tracking and Tag Configuration"}
            step1description={
              "We set up Google Analytics tracking with precision. Our team configures custom events and goal tracking. We also establish UTM parameters to monitor campaign effectiveness."
            }
            step2={"User Behavior Analysis and Audience Segmentation"}
            step2description={
              "We analyze visitor behavior and categorize users based on engagement patterns. Our team segments audiences to refine targeting. We also track session durations and interaction rates to measure engagement."
            }
            step3={"Traffic Source Evaluation and Conversion Tracking"}
            step3description={
              "We assess where visitors originate and identify high-performing traffic sources. Our team tracks conversion journeys and maps user touchpoints. We also measure goal completions to improve marketing efficiency."
            }
            step4={"Custom Dashboard Creation and Reporting"}
            step4description={
              "We design custom dashboards that display real-time data. Our team organizes reports based on key performance indicators. We also integrate visualization tools to simplify complex insights."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our Google Analytics Services"}
            title1={"Data-Driven Marketing Decisions"}
            subtitle1={
              "We provide structured insights that guide digital strategy. This helps businesses allocate budgets effectively and improve targeting."
            }
            title2={"User Behavior Understanding"}
            subtitle2={
              "We analyze engagement trends and customer interactions. This improves content strategies and refines user journeys."
            }
            title3={"Customizable Tracking Solutions"}
            subtitle3={
              "We implement tailored tracking based on business needs. Custom reports highlight performance metrics that matter most."
            }
            title4={"Real-Time Performance Insights"}
            subtitle4={
              "We monitor website data and detect traffic fluctuations. This allows for timely adjustments that improve digital campaigns."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>Turn Website Data into Competitive Advantage</h2>}
            subtitle="At Riches Media Digital, we convert raw analytics into meaningful insights that fuel business growth. Our Google Analytics solutions track visitor behavior and measure campaign effectiveness. We analyze engagement trends and refine user journeys. This helps businesses optimize digital interactions and improve conversion pathways. Every metric we track serves a purpose, delivering clarity that drives better marketing and operational decisions."
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/analytics.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Google Analytics Services Will You Get"}
            invert={!dark}
            title1={"Expert Google Analytics Implementation"}
            title2={"Precise User Behavior Tracking"}
            title3={"Custom Reports for Business Growth"}
            title4={"In-Depth Campaign Performance Analysis"}
            title5={"Data-Backed Optimization Strategies"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is Google Analytics?"
            a1="Google Analytics is a web analytics tool that tracks and reports website activity. It involves monitoring user sessions and measuring key performance indicators. It further encircles tracking conversions to evaluate marketing success."
            q2="Why is Google Analytics important for my business?"
            a2="Google Analytics provides data that helps businesses understand user behavior and campaign performance. Accurate insights improve targeting and reduce wasted ad spend. Businesses that use Google Analytics refine strategies based on real-time metrics."
            q3="How long does it take to see useful data in Analytics?"
            a3="Google Analytics starts collecting data immediately after implementation. Businesses see meaningful insights within one to two weeks based on visitor volume and tracking configurations. Ongoing analysis helps refine digital strategies over time."
            q4="What metrics should I track in Google Analytics?"
            a4="Businesses should monitor traffic sources and conversion rates. Engagement metrics such as bounce rates and session durations also provide valuable insights."
            q5="How do you customize Analytics tracking for a business?"
            a5="We configure custom goals and event tracking based on business objectives. Our team sets up funnel tracking and audience segmentation. We also establish reporting dashboards that highlight priority metrics."
            q6="How do you measure success in Google Analytics?"
            a6="Google Analytics success is measured through conversion rate improvements and traffic quality. We track user engagement trends and goal completions to streamline marketing efforts."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
